import { Link, useLocation, useNavigation } from 'react-router-dom';
import { MenuItemProps } from '../../types/global';

export default function MenuItems({ item, className, isExpanded }: Readonly<MenuItemProps>) {
  const disabledTooltip = `${item.name}: You do not have access. Please contact your account manager or email helpdesk@policyinpractice.co.uk`;
  const disabledClassName = 'text-piptext-strong cursor-not-allowed pointer-events-none';
  const location = useLocation();
  const navigation = useNavigation();
  const userOnPage = (pathname: string, path: string) => pathname === path || pathname.startsWith(`${path}/`);
  const isActive = userOnPage(location.pathname, item.path);
  const isSelected = userOnPage((navigation.location ?? location).pathname, item.path);

  const liClasses = [
    'rounded-lg',
    isSelected ? 'bg-pipbg-subtle hover:bg-gray-50' : 'hover:bg-gray-100'
  ];

  const anchorClasses = [
    className,
    'flex',
    'items-center',
    'rounded-md',
    'transition-colors',
    item.enabled ? '' : disabledClassName,
    isExpanded ? 'gap-2' : 'grow justify-center'
  ];

  return (
    <li
      className={liClasses.join(' ')}
      title={item.enabled ? item.name : disabledTooltip}
    >
      <Link
        to={item.path}
        className={anchorClasses.join(' ')}
        aria-label={`Navigate to ${item.name}`}
        aria-current={isActive ? 'page' : undefined}
        aria-disabled={!item.enabled}
      >
        {isExpanded ? (
          <span aria-hidden className={`${isSelected ? 'text-primary' : 'text-piptext-body'}`}>{item.icon}</span>
        ) : (
          <span
            aria-hidden
            aria-label={`Navigate to ${item.name}`}
            title={item.name}
            className={`${isSelected ? 'text-primary' : 'text-piptext-body'}`}
          >
            {item.icon}
          </span>
        )}
        <span className={`${isExpanded ? 'inline grow' : 'hidden'} ${isSelected ? 'text-piptext-strong font-semibold' : 'text-piptext-strong'}`}>
          {item.name}
        </span>
      </Link>
    </li>
  );
}
